'use client';
const ICON_STROKE_MAP = {
  12: 1.25,
  16: 1.5,
  20: 1.5,
  24: 1.5,
  28: 1.5,
  32: 2,
  48: 2
};
const ICON_SIZES = Object.keys(ICON_STROKE_MAP);
const ICON_DEFAULT_SIZE = 24;

export { ICON_DEFAULT_SIZE, ICON_SIZES, ICON_STROKE_MAP };
